<template>
  <v-container fluid>
    <page-header :use-list="[]"></page-header>
    <v-row>
      <v-data-table
        style="width: 100%;"
        :headers="columns"
        :items="boardData"
        :items-per-page="10"
        class="test elevation-1 notice-table"
        calculate-widths
        @click:row="onClick"
      >
      </v-data-table>
    </v-row>
    <bill-detail :show-event="component_show" :detail-data="selectData"></bill-detail>
  </v-container>
</template>

<script>
import localStore from '@/utils/localStore'
import BillDetail from '@/views/pc/manager/BillDetail'
import { getBillCount, getBillList } from '@/api/greenCommon/common'
import PageHeader from '@/layout/components/PageHeader'

var Pagination = tui.Pagination

export default {
  components: {
    BillDetail,
    PageHeader
  },
  data() {
    return {
      isAdmin: false,
      layer_type: 'BillDetail',
      component_key: 1,
      component_show: false,
      row_num: 0,
      paginationInstance: null,
      itemPerPageList: [5, 10, 15, 30, 50, 100],
      // 사용자 조회시 넘어가는 파라미터 (조회조건)
      retrieveData: {
        user_id: this.isAdmin == false ? localStore.get('userId') : '', // 고객아이디
        user_nm: '', // 고객명
        start_date: '', // 청구년월일 START
        end_date: '', // 청구년월일 END
        itemsPerPage: 10,
        currentPage: 1 // 현재 페이지
      },
      // 명세서 상세 조회시 넘어가는 파라미터
      detailData: {},
      totalItems: 0, // 총 게시물 수
      // 그리드 기본 데이터
      boardData: [],
      // 그리드 컬럼 데이터
      columns: [],
      // 그리드 만드는데 필요한 옵션값을 담아둔다.
      options: {
        header: { height: 30 }, // 헤더 높이
        scrollY: true,
        rowHeight: 30, // 각행의 높이
        bodyHeight: 'auto' // 그리드 높이
      },
      // 선택된 셀의 데이터를 담아둔다.
      selectData: {}
    }
  },
  mounted() {
    this.initGrid()
    this.initData()
    this.retrieveBoard()
    this.initPagination()
  },
  methods: {
    initData() {
      // 관리자 구분
      if ((this.$store.state.user.grp_auth || '') === 'usergroup001') this.isAdmin = true
    },
    setClose() {
      this.retrieveBoard()
    },
    initPagination() {
      // 페이징 처리를 진행한다. 데이터 총갯수를 조회한 이후 처리한다.
      getBillCount(this.retrieveData).then(response => {
        // RealGrid에 조회한 데이터를 넣는다.
        this.totalItems = response

        // 현재 페이지 초기화
        this.retrieveData.currentPage = 1

        this.paginationInstance = new Pagination(this.$refs.pagination, {
          totalItems: this.totalItems, // 총 게시물 수
          itemsPerPage: this.retrieveData.itemsPerPage, // 페이지 당 개수
          visiblePages: 5 // 페이지표시갯수
        })
        // 페이지처리 버튼 클릭시 이벤트
        this.paginationInstance.on(
          'afterMove',
          function(event) {
            // 대상 페이지 번호
            this.retrieveData.currentPage = event.page
            // 그리드 데이터를 재 조회
            this.retrieveBoard()
          }.bind(this)
        )
      })
    },
    retrieveBoard() {
      getBillList(this.retrieveData).then(response => {
        $.each(response, function(idx, item) {
          $.each(item, function(key, value) {
            if (key === 'bill_date') {
              item.bill_date_text_temp =
                value.substr(0, 4) + '년 ' + value.substr(4) + '월' + ' 명세서 '
              item.bill_date_text =
                value.substr(0, 4) + '년 ' + value.substr(4) + '월'
            }
            if (key === 'amount_text') { item.amount_text_temp = value + ' 원' }
          })
        })

        // RealGrid에 조회한 데이터를 넣는다.
        this.boardData = response
      })
    },
    onClick(cell) {
      // 선택된 행을 데이터셋에 넣어둔다.
      this.selectData = cell
      this.component_show = !this.component_show
    },
    moveDetail(rowData) {
      this.detailData = rowData
      // 상세화면으로 페이지 이동한다.
      this.layer_type = 'BillDetail'
      this.component_key++
      this.component_show = true
    },
    // 페이지이동시 함수
    beforeDestroy: function() {
      // grid 초기화
      this.$refs.tuiGrid.invoke('destroy')
    },
    initGrid() {
      // 그리드 컬럼데이터 세팅
      var newColumns = [
        {
          text: 'No',
          value: 'row_num',
          align: 'center',
          sortable: false,
          width: 66,
          class: 'text-h6'
        },
        {
          text: '고객명',
          value: 'user_nm',
          align: 'center',
          width: 130,
          class: 'text-h6'
        },
        {
          text: '청구년월',
          value: 'bill_date_text_temp',
          align: 'center',
          minWidth: 170,
          class: 'text-h6'
        },
        {
          text: '이용금액',
          value: 'amount_text_temp',
          align: 'center',
          class: 'text-h6',
          width: 150
        }
      ]
      // 위에서 만든 컬럼데이터를 넣는다.
      this.columns = newColumns
    }
  }
}
</script>

<style lang="less" scoped>
</style>
